// biome-ignore lint/style/useFilenamingConvention: TanStack Router uses $param convention for dynamic routes
import { createRoute } from '@tanstack/react-router';
import { ProductionDeclarationGuidelinePage } from '@/pages/production-declaration/production-declaration-guideline-page';
import { Route as ProductionDeclarationRoute } from './production-declarations.$id';

export const Route = createRoute({
  getParentRoute: () => ProductionDeclarationRoute,
  path: 'guideline',
  component: () => <ProductionDeclarationGuidelinePage />,
  staticData: {
    stepKey: 'guideline',
  },
});
